import React from 'react';
import Billing from '@dashboard/scenes/BillingSettings/scenes/Billing';
import PageHeader from '@dashboard/components/PageHeader';

const SettingsBilling = () => {
  return (
    <div className="p-4 space-y-4">
      <PageHeader title="Billing" description="View your invoices and manage payment methods." />

      <div className="mb-32">
        <Billing />
      </div>
    </div>
  );
};

export default SettingsBilling;
